/* PENNELLO mobile-accordion.js — safe, no HTML, no globals */
(() => {
  const root = document; // limit scope
  const toggles = root.querySelectorAll('[data-accordion-toggle]');
  if (!toggles.length) return;

  toggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('[data-accordion]');
      const panel = wrap?.querySelector('[data-accordion-panel]');
      if (!panel) return;

      const open = wrap.classList.toggle('is-open');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // hydrate opened by default
  root.querySelectorAll('[data-accordion].is-open [data-accordion-panel]')
      .forEach(p => p.style.maxHeight = p.scrollHeight + 'px');
})();
